import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  GeneratedClientCodeLoginRequest,
  GeneratedClientLoginRequest,
  GeneratedLoginResponse,
  GeneratedPracticeLoginRequest,
  GeneratedPracticeLoginResponse,
  GeneratedRefreshTokenResponse,
} from '@repo/backend-api-spec';
import { NO_AUTH } from '../../interceptors/auth.interceptor';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseAPI {
  public async clientLogin(data: GeneratedClientLoginRequest) {
    return await lastValueFrom(
      this.post<GeneratedClientLoginRequest, GeneratedLoginResponse, 'INVALID_CREDENTIALS' | 'INVALID_CAPTCHA' | 'USER_HAS_NO_PASSWORD'>(
        '/unauthenticated/client-login',
        {
          body: data,
          context: new HttpContext().set(NO_AUTH, true),
        },
      ),
    );
  }

  public async clientCodeLogin(data: GeneratedClientCodeLoginRequest) {
    return await lastValueFrom(
      this.post<GeneratedClientCodeLoginRequest, GeneratedLoginResponse, 'INVALID_CREDENTIALS' | 'INVALID_CAPTCHA'>(
        '/unauthenticated/client-code-login',
        {
          body: data,
          context: new HttpContext().set(NO_AUTH, true),
        },
      ),
    );
  }

  /** Exchanges a login token from the staff frontend for a therapist's practice session; see PracticeSessionService. */
  public async practiceLogin(data: GeneratedPracticeLoginRequest) {
    return await lastValueFrom(
      this.post<GeneratedPracticeLoginRequest, GeneratedPracticeLoginResponse, 'INVALID_CREDENTIALS'>('/unauthenticated/practice-login', {
        body: data,
        context: new HttpContext().set(NO_AUTH, true),
      }),
    );
  }

  public async refreshAccessToken() {
    return await lastValueFrom(
      this.post<object, GeneratedRefreshTokenResponse, 'INVALID_REFRESH_TOKEN' | 'RESOURCE_NOT_FOUND'>('/unauthenticated/client-token', {
        body: {},
        context: new HttpContext().set(NO_AUTH, true),
      }),
    );
  }

  public async logout() {
    return await lastValueFrom(
      this.post('/unauthenticated/client-logout', {
        body: {},
        context: new HttpContext().set(NO_AUTH, true),
      }),
    );
  }
}
